import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScaleService {
  setScale() {
    let scale = window.innerWidth / 1920;
    if (scale < 0.75) scale = 0.75;
    if (scale > 1) scale = 1;
    document.documentElement.style.setProperty('--scale', scale.toString());
  }
}
